import { z } from "zod";

export const requiredHttpUrl = (requiredError: string, invalidError: string) =>
  z
    .string({ error: requiredError })
    .trim()
    .min(1, { error: requiredError })
    .pipe(
      z.url({
        protocol: /^https?$/,
        error: invalidError,
      }),
    );
